import React, { Component } from 'react';
import './style.css';
import User from './Components/user';
import Car from '../../img/unit.png';

const DetalleRuta = ({ rutaSeleccionada, velocity, clientes }) => {
    if (rutaSeleccionada.key !== undefined) {
        let pasajerosP = rutaSeleccionada.prograDia.Pasajeros !== undefined ? rutaSeleccionada.prograDia.Pasajeros : [];
        let pasajerosp = rutaSeleccionada.prograDia.pasajeros !== undefined ? rutaSeleccionada.prograDia.pasajeros : [];
        let paradas = rutaSeleccionada.rutaViaje.paradas !== undefined ? rutaSeleccionada.rutaViaje.paradas : [];
        let velo = velocity !== null ? velocity.vActual !== undefined ? velocity.vActual : 0 : 0;
        let vehiculo = rutaSeleccionada.vehiculo;
        return (
            <div className="row">
                <div className="col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
                    <div className="col-md-11 col-sm-12 d-flex flex-row justify-content-center align-items-center lineBtn">
                        <p className="rutasText fill1">Detalle de unidad</p>
                        <div style={{ width: 50, height: 1 }} />
                        <img className="image" src={Car} />
                        <p className="space resaltedText">{`${vehiculo.movil} ${vehiculo.tipo_vehiculo} ${vehiculo.placa}`}</p>
                        <div style={{ width: 50, height: 1 }} />
                        <p className="rutasText">Estado: {rutaSeleccionada.prograDia.estado === 'sinced' ? 'Abordando' : rutaSeleccionada.prograDia.estado}</p>
                    </div>
                </div>
                <div className="col-md-12 col-sm-12 scrollView">
                    <div className="col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
                        <div className="col-md-6 col-sm-12 d-flex flex-column justify-content-center align-items-start lineDe">
                            <p className="textDetails">Conductor: {rutaSeleccionada.conductor.nombre}</p>
                            <br />

                            <p className="textDetails">Velocidad: {velo} kmp</p>

                            <br />
                            <b style={{ marginBottom: 10 }} className="rutasText">Ruta:</b>
                            <p className="textDetails">
                            {rutaSeleccionada.rutaViaje.inicio.nombre + ' > '}
                            {
                                paradas.map(elem =>  {
                                return elem.referencia;
                            }).join(" > ")
                            }
                            { ' > ' + rutaSeleccionada.rutaViaje.destino.nombre}
                            </p>
                        </div>
                        <div className="col-md-6 col-sm-12 d-flex flex-column justify-content-start align-items-center">
                            <div style={{ width: '100%' }} className="row">
                                <b style={{ marginBottom: 10 }} className="rutasText">Listado de pasajeros:</b>
                            </div>
                            <div className="d-flex flex-wrap">
                                {pasajerosP.map(snapP => (
                                    <User color={'green'} name={snapP.nombre} />
                                ))}
                                {pasajerosp.map(snapP => (
                                    <User color={snapP.subio ? 'green' : 'red'} name={snapP.nombre} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return null
}

export default DetalleRuta;


// WEBPACK FOOTER //
// ./src/Components/Rutas/detalleRuta.js